import React from 'react'

import { Switch } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { Fld, Lbl } from './shared'

/**
 * fields for column type Color
 */
export default function FieldColor() {
  const { id, value, setValue } = useCreateColumnContext()

  return (
    <>
      <Fld>
        <Lbl>Alpha Channel</Lbl>
        <Switch
          id={`${id}-color-transparent`}
          checked={value.colorOptions.colorTransparent}
          onClick={(isChecked) => {
            setValue({
              colorOptions: {
                ...value.colorOptions,
                colorTransparent: isChecked,
              },
            })
          }}
        />
      </Fld>
    </>
  )
}
